const YEAR_MS = 365 * 24 * 60 * 60 * 1000;
const BASE_DURATION = YEAR_MS;
export default BASE_DURATION;
